import React, { useEffect } from 'react'
import styled, { keyframes } from 'styled-components'

import TermsScreen from './TermsScreen'
import PrivacyScreen from './PrivacyScreen'
import { Button } from 'components'
import { Header, Footer } from 'features'

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100vh;
    background-color: #2B2B2B;
`

const Body = styled.div`
    margin: 0 9rem;
    @media (max-width: 1100px) {
        margin: 0 3rem;
    }
`

const rotate = keyframes`
    to {
        background-position: 200% center;
    }
`;


const Title = styled.div`
    background: #7209B7;
    background: -webkit-repeating-radial-gradient(circle farthest-corner at center center, #7209B7 0%, #F72585 100%);
    background: -moz-repeating-radial-gradient(circle farthest-corner at center center, #7209B7 0%, #F72585 100%);
    background: repeating-radial-gradient(circle farthest-corner at center center, #7209B7 0%, #F72585 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-size: 200% auto;
    font-size: 4rem;
    font-weight: bolder;
    animation: ${rotate} 5s linear infinite;
    text-align: center;
    text-decoration: underline;
    margin: 2rem;
`

const LegalScreen = props => {
    useEffect(() => {
        window.scrollTo(0,0)
    }, [])

    let title
    let content
    switch(props.type){
        case 'terms-of-service':
            title = 'Terms of service'
            content = <TermsScreen/>
            break
        case 'privacy-policy':
            title = 'Privacy policy'
            content = <PrivacyScreen/>
            break
        default:
            title = 'Something went wrong'
    }
    return(
        <Container>
            <Header/>    
            <Title>{title}</Title>
            <Body>{content}</Body>
            <Footer/>
        </Container>
    )
}

export default LegalScreen